import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { RechazosTracesNoCumplimientoViewModel, TNTRetrievalAttachmentViewModel } from '../rechazostraces.types';
import { RechazosTracesService } from '../rechazostraces.service';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { NavMenuService } from '../../../../core/components/navmenu/navmenu.service';

@Component({
    selector: 'app-rechazostraces-wrapper-no-cumplimiento',
    templateUrl: './rechazostraces-wrapper-no-cumplimiento.component.html',
})
export class RechazosTracesWrapperNoCumplimientoComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    rechazoTracesNoCumplimiento: RechazosTracesNoCumplimientoViewModel;
    formGroup: FormGroup;

    listUrl = '/importacion/rechazostraces';
    private CHEDPP: string | null;

    activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        this.CHEDPP = params.get('CHEDPP');
        if (this.CHEDPP) {
            this.getRechazoTracesNoCumplimiento(this.CHEDPP);
        }
    });

    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private globalService: GlobalService,
        protected rechazosTracesService: RechazosTracesService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private navMenuService: NavMenuService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.preparePresentation();
    }

    private preparePresentation(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            basic: this.fb.group({
                MotivosList: [],
                MedidasList: [],
                ComentarioMedidas: '',
                LugarInspeccion: null,
                CiudadInspeccion: '',
                CodigoISOInspeccion: '',
                CodigoPostalInspeccion: '',
                DireccionInspeccion: '',
                NombreInspector: '',
                PaisInspeccion: '',
                FechaTipoInspeccion: null,
                PFC: '',
                TipoLugarInspeccion: '',
                TipoInspControlSeguimientoNoSintomas: '',
                TipoInspControlSeguimientoSiSintomas: '',
                TipoInspSupervisionPuestoInsp: '',
                Unlocode: '',
                Documentos: [],
            }),
        });
    }

    private getRechazoTracesNoCumplimiento(CHEDPP: string): void {
        this.rechazosTracesService
            .getRechazoTracesNoCumplimiento(CHEDPP)
            .pipe(
                tap((rechazoTracesNoCumplimiento: RechazosTracesNoCumplimientoViewModel) => {
                    this.rechazoTracesNoCumplimiento = rechazoTracesNoCumplimiento;
                    if (this.rechazoTracesNoCumplimiento !== null) {
                        this.rechazoTracesNoCumplimiento.CHEDPP = this.CHEDPP!;
                        this.navMenuService.updateMenuServiceForRechazoTraces(this.rechazoTracesNoCumplimiento?.CHEDPP);
                    }
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.formGroup.disable();
                    return of([]);
                }),
            )
            .subscribe();
    }

    onBack(): void {
        this.router.navigate([this.listUrl]);
    }

    onDownload(model: TNTRetrievalAttachmentViewModel): void {
        this.rechazosTracesService.getDocumentoRechazoTraces(model).subscribe({
            next: res => {
                this.OpenDownloadedFile(res);
            },
            error: error => {
                this.catchServerError(error);
            },
        });
    }
}
